import imageShirt from '@/assets/shirtBase-xs.png';
import { ShirtShieldProps, MakeMaybe, Prettify } from '@/types';

type ColorType = Prettify<
  MakeMaybe<ShirtShieldProps, 'startColor' | 'endColor'>
>;

type Props = Prettify<{
  colors?: ColorType;
  withShield?: boolean;
  id?: string | number;
}>;

const TshirtClub = (props: Props) => {
  const { colors, id } = props;
  return (
    <svg
      enableBackground="new 0 0 28 31"
      id={`svg--tshirtclub__key--${String(id)}`}
      version="1.1"
      viewBox="0 0 28 31"
      width="100%"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <image
          height="504"
          href={imageShirt}
          overflow="visible"
          transform="matrix(6.000804e-02 0 0 6.112247e-02 1.5635 0.1943)"
          width="414"
        />
      </g>
      <g>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`tshirtclub__key--${id}`}
          x1="5.1409"
          x2="21.3773"
          y1="30.1535"
          y2="2.0311"
        >
          <stop offset="0" stopColor={colors?.endColor ?? '#FFF'} />
          <stop offset="1" stopColor={colors?.startColor ?? '#FFF'} />
        </linearGradient>
        <path
          d="M1.6,11.9c0,0,0.2-2.5,0.3-3.3c0-0.8,0.4-2.3,0.4-2.3s0-2.1,2.5-3.3c0,0,1.2-0.7,1.7-0.8
          c0,0,3.6-1.6,4.3-1.9h0.4c0,0,1.1,0.3,2.9,0.2c0,0,1.6,0,2.9-0.3c0,0,0.2-0.1,0.7,0.1c0,0,4.6,2.1,5.2,2.7l1.5,1
          c0,0,1.1,0.7,1.3,2.3c0,0,0.5,1.9,0.5,4.3c0,0,0.1,0.6,0.1,1.4c0,0-1.3,0.6-2,0.7c0,0-1.9,0.1-2.5,0c0,0-0.1,0-0.1-0.5l-0.3-0.4
          L21.5,13l-0.2,4.3c0,0,0,1.5,0.3,3l0.2,4.7l0.1,3.9l0.1,1.6c0,0-0.9,0.4-2.6,0.4H15c0,0-5.4,0-6.1-0.1l-2.8-0.2c0,0-0.2,0-0.1-0.4
          L6.2,25l0.2-5.6l0-5l0-1.8c0,0,0-0.3-0.1-0.3c0,0-0.1,0-0.1,0.4S5.8,13,5.8,13s-1.9-0.1-2.2-0.2c0,0-1.7-0.3-1.8-0.5
          C1.8,12.3,1.5,12.2,1.6,11.9z"
          fill={`url(#tshirtclub__key--${id})`}
          style={{ mixBlendMode: 'multiply' }}
        />
      </g>
    </svg>
  );
};

export default TshirtClub;
